// extracted by mini-css-extract-plugin
export default {"ctn":"battary_ctn__2EvqI","textBox":"battary_textBox__58JPL","paramsBox":"battary_paramsBox__8UJEl","paramsItem":"battary_paramsItem__597IZ"};